var _iub = _iub || [];
_iub.csConfiguration = {
  cookiePolicyId: 23957984,
  siteId: 1479997,
  lang: "it",
  cookiePolicyUrl: "https://www.csf.lombardia.it/privacy",
  cookiePolicyInOtherWindow: true,
  enableRemoteConsent: true,
  localConsentDomain: "csf.lombardia.it",
  callback: {
    onConsentGiven: function () {
      dataLayer.push({
        event: "iubenda_consent_given",
      });
    },
  },
  banner: {
    slideDown: false,
    applyStyles: false,
  },
};
window._iub = _iub;

(function (w, d) {
  var loader = function () {
    var s = d.createElement("script");
    var tag = d.getElementsByTagName("script")[0];
    s.src = "https://cdn.iubenda.com/cookie_solution/safemode/iubenda_cs.js";
    tag.parentNode.insertBefore(s, tag);
  };
  if (w.addEventListener) {
    w.addEventListener("load", loader, false);
  } else if (w.attachEvent) {
    w.attachEvent("onload", loader);
  } else {
    w.onload = loader;
  }
})(window, document);



// WEBPACK FOOTER //
// ./js/inc/iubenda.js